import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-container" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Welcome to the directory!", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Choose your city", -1)),
    _createElementVNode("a", {
      class: "uk-text-large uk-padding uk-button uk-button-primary",
      href: _ctx.getCityDirectoryPage('oakland')
    }, "Oakland Directory", 8, _hoisted_2)
  ]))
}